export default __webpack_public_path__ + "static/media/information--train-or-light-rail-station--g1.1137babb.png";